module.exports = __webpack_public_path__ + "img/graphic.2fa72538.png";